module.exports = __webpack_public_path__ + "img/images_homebanner_2_1.5d68e1e8.png";